import React, {useContext, useEffect, useRef, useState} from 'react';
import {usePopup} from 'popup/PopupContext';
import {useSessionConfiguration} from 'util/SessionConfigurationContext';
import {UserContext} from 'components/user/UserContext';
import {addMoneyRequest} from 'util/api';
import {centsToString} from 'util/cashFormatter';
import AddMoneySendArrow from 'components/donate/AddMoneySendArrow';
import 'styles/donate/GenericMoney.css';

const AddMoneyMuscle = ({initialAmount = '500', openInNewTab = false}) => {
    const [amount, setAmount] = useState('');
    const inputRef = useRef(null); // Reference for the input field
    const {closePopup} = usePopup();
    const {monitorPaymentWindow} = useSessionConfiguration();
    const {user} = useContext(UserContext);
    const [existingBalance, setExistingBalance] = useState(user.balance === 0);
    const [isLegitAmount, setIsLegitAmount] = useState(false);

    const [isSending, setIsSending] = useState(false);

    useEffect(() => {
        const numAmount = Number(amount);
        const localIsLegit = !isNaN(numAmount) && numAmount > 0;
        setIsLegitAmount(localIsLegit);
    }, [amount]);

    useEffect(() => {
        setExistingBalance(user.balance === 0);
    }, [user.balance]);

    useEffect(() => {
        if (initialAmount !== '') {
            let numAmount = Number(initialAmount);
            if (!isNaN(numAmount) && numAmount > 0) {
                numAmount = Math.ceil(numAmount / 100) * 100;
                if (numAmount < 500) {
                    numAmount = 500;
                }
                setAmount((numAmount / 100).toFixed(0));
            }
        }
    }, [initialAmount]);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    const handleSubmit = async () => {
        try {
            if (isSending || !isLegitAmount) {
                return;
            }
            setIsSending(true);
            const centAmount = parseInt(amount) * 100;
            if (openInNewTab) {
                const data = await addMoneyRequest(centAmount, window.location.origin + '/close-the-window');
                closePopup();
                const paymentWindow = window.open(data.url, '_blank');
                monitorPaymentWindow(paymentWindow);
            } else {
                const data = await addMoneyRequest(centAmount, window.location.href);
                window.location.href = data.url;
            }
        } catch (error) {
            setIsSending(false);
            console.error('Error:', error);
            alert('Failed to create checkout session. Please try again.');
        }
    };

    const handleChange = (e) => {
        const value = e.target.value;
        if (/^\d{0,6}$/.test(value) || value === '') {
            console.log('Valid input:', value);
            setAmount(value);
        } else {
            e.preventDefault();
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
        if (e.key === '-' || e.key === 'e' || e.key === '+') {
            e.preventDefault();
        }
    };

    return (
        <>
            {existingBalance ? '' : `${centsToString(user.balance)} +`}
            <div className="add-money-input-outline" data-testid="add-money-input-outline">
                {existingBalance ? '+ ' : ''}$
                <input
                    type="number"
                    min="1"
                    data-testid="add-money-input"
                    value={amount}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown} // Trigger on Enter key
                    ref={inputRef} // Attach the ref to the input field
                    className={'add-money-input'}
                />
                <AddMoneySendArrow handleSubmit={handleSubmit} isSending={isSending} isLegitAmount={isLegitAmount}/>
            </div>
        </>
    );
};

export default AddMoneyMuscle;